import { NewFormDetails } from 'src/app/models/enroll';
import { ReadConfigService } from './../../../shared/services/common/read-config.service';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { StepperComponent, TabStripComponent } from '@progress/kendo-angular-layout';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-enroll-member',
  templateUrl: './enroll-member.component.html',
  styleUrls: ['./enroll-member.component.css']
})
export class EnrollMemberComponent implements OnInit {
  @ViewChild('stepper', { static: true })
  public stepper: StepperComponent;
  currentStep = 1;
  dataLoading = true;
  steps: any;
  current = 0;
  progressValue: number;
  labelSettings = { format: 'percent', position: 'center', visible: false };
  fPersonalInfoData: NewFormDetails;
  currentScreen: any;
  wizardData: any;
  @ViewChild('tabstrip') tabstrip: TabStripComponent;
  @Input() set enrollmentDataItem(enrollData: any) {
    if(enrollData) {
      this.pendingEnrollInfo(enrollData);
    }
  }
  @Output() formDirtyOrTouched = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private usersService: UsersService,
    private readConfigService: ReadConfigService,
    private cdRef: ChangeDetectorRef,
    private notificationService: DisplayNotificationService
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.steps = this.readConfigService.getStepperLabels();
      this.dataLoading = false;
    }, 500);
    this.fPersonalInfoData = new NewFormDetails;
    this.getOrganizationInfo();
  }

  ngDoCheck() {
    this.cdRef.detectChanges();
  }

  getOrganizationInfo() {
    this.usersService.getOrgProfile().subscribe((response) => {
      if (response && response.success) {
        const organizationType = response.data.organizationType.trim();
        const orgId = response.data.id;
        sessionStorage.setItem('orgType', organizationType);
        sessionStorage.setItem('orgId', orgId);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }

  pendingEnrollInfo(data: any) {
    this.wizardData = data;
  }

  disableHistory(value: boolean) {
    this.formDirtyOrTouched.emit(value);
  }

  setCurrentScreen(e: any) {
    this.currentScreen = e.option;
    this.wizardData = e;
    this.current = this.currentScreen;
    this.progressValue = this.currentScreen * 33.3;
    this.labelSettings = this.progressValue > 0 ? { format: 'percent', position: 'center', visible: false }
      : { format: 'percent', position: 'center', visible: false };
    this.tabstrip.selectTab(this.currentScreen);
  }

}
